import { render, staticRenderFns } from "./PracticePage.vue?vue&type=template&id=f92f9182&scoped=true&"
import script from "./PracticePage.vue?vue&type=script&lang=js&"
export * from "./PracticePage.vue?vue&type=script&lang=js&"
import style0 from "./PracticePage.vue?vue&type=style&index=0&id=f92f9182&prod&scoped=true&lang=css&"
import style1 from "./PracticePage.vue?vue&type=style&index=1&id=f92f9182&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92f9182",
  null
  
)

export default component.exports